import { BBOT_DJANGO_SERVER } from "Config";
import { OPContainer, PageLoadingSpinner, Space } from "top-component-library";
import { LegacyLinkAlert } from "./styles";
import { usePresentationSettings } from "./usePresentationSettings";
import MenuBannersCard from "./sections/MenuBannersCard";
import StoreLogoOrBrandingCard from "./sections/StoreLogoOrBrandingCard";
import GuestMessagesCard from "./sections/GuestMessagesCard";
import StoreHoursCard from "./sections/StoreHoursCard";
import OtherSettingsCard from "./sections/OtherSettingsCard";

const PresentationToGuests = ({ selectedCustomer, userInfo }) => {
  const settings = usePresentationSettings(selectedCustomer);
  const legacyLink =
    BBOT_DJANGO_SERVER +
    (userInfo?.role === "admin" ? "/superuser/console/#!/presentation" : "/owner/console/#!/presentation");

  return (
    <OPContainer
      title="Presentation to Guests"
      url="/presentation"
      selectedCustomer={selectedCustomer}
      userInfo={userInfo}
    >
      <div className="margin-bottom-4">
        <LegacyLinkAlert
          message={
            <span>
              We&apos;ve updated our Presentation to Guests page! We&apos;ll retire the old page soon but you can view
              it <a href={legacyLink}>here.</a>
            </span>
          }
        />
      </div>
      {settings.isLoading ? (
        <PageLoadingSpinner />
      ) : (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <MenuBannersCard
            mobileBannerUrl={settings.mobileBannerUrl}
            desktopBannerUrl={settings.desktopBannerUrl}
            onUpload={settings.uploadAsset}
            onDelete={settings.deleteAsset}
          />
          <StoreLogoOrBrandingCard
            brandParent={settings.brandParent}
            brandParentLogoUrl={settings.brandParentLogoUrl}
            canEditBranding={settings.canEditBranding}
            logoUrl={settings.logoUrl}
            customerName={selectedCustomer?.name_for_owner}
            onUpload={settings.uploadAsset}
            onDelete={settings.deleteAsset}
            onDisconnect={settings.disconnectFromBrand}
          />
          <GuestMessagesCard
            messages={settings.messages}
            onChange={settings.changeMessage}
            onSave={settings.saveMessages}
          />
          <StoreHoursCard
            storeHours={settings.storeHours}
            onChange={settings.setStoreHours}
            onSave={settings.saveStoreHours}
          />
          <OtherSettingsCard
            orderNumberPrefix={settings.orderNumberPrefix}
            setOrderNumberPrefix={settings.setOrderNumberPrefix}
            saveOrderNumberPrefix={settings.saveOrderNumberPrefix}
            statementDescriptor={settings.statementDescriptor}
            setStatementDescriptor={settings.setStatementDescriptor}
            saveStatementDescriptor={settings.saveStatementDescriptor}
            appProperties={settings.appProperties}
            setAppProperty={settings.setAppProperty}
            saveAppProperties={settings.saveAppProperties}
            sendSmsDrinkReminder={settings.sendSmsDrinkReminder}
            setSendSmsDrinkReminder={settings.setSendSmsDrinkReminder}
            smsFeatureEnabled={settings.smsFeatureEnabled}
          />
        </Space>
      )}
    </OPContainer>
  );
};

export default PresentationToGuests;
